import React, {useState} from 'react';
import { format, addMonths, subMonths, startOfMonth, endOfMonth, eachDayOfInterval, startOfWeek, isBefore, isEqual } from 'date-fns';
import { es as localees, enGB as localeen, de as localede } from "date-fns/locale";

import styles from './emdbDatePicker.module.less';

function EmdbDatePicker ({value,onChange,disabledDays,locale}) {
  const today = new Date().setHours(0,0,0,0);
  const [currentDate, setCurrentDate] = useState(value!=null ? value: new Date());

  const locales = { es:localees, en:localeen, de:localede };

  const handlePreviousMonth = () => {
    setCurrentDate(subMonths(currentDate, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(addMonths(currentDate, 1));
  };

  const checkDay = (day) => {

    if(!isBefore(day,today) && disabledDays[format(day,"yy")][format(day,"MM")][format(day,"dd")] === 0) onChange (day);

  };

  const renderDays = () => {

    const startDate = startOfMonth(currentDate);
    const endDate = endOfMonth(currentDate);
    const days = eachDayOfInterval({ start:startDate, end:endDate});
    //const firstOfWeek = startOfWeek(currentDate);
    //const days = eachDayOfInterval({ start: startOfWeek(startDate, {weekStartsOn: 1}), end: endOfWeek(endDate, {weekStartsOn: 1}) });

    return days.map((day, index) => {

      let dayClass = [styles.day];
      if (isEqual(day,startDate)) dayClass.push(styles['firstDay'+format(startDate, 'i')])
      if (isEqual(day,today)) dayClass.push(styles['today']);
      if (isEqual(day,value)) dayClass.push(styles['selectday']);

      if(isBefore(day,today)) dayClass.push(styles['disable']);

      if(disabledDays[format(day,"yy")][format(day,"MM")][format(day,"dd")] === 1  ) dayClass.push(styles['disable']);


      return(
        <div
          key={index}
          className={dayClass.join(' ')}
          onClick={() => checkDay(day)}
        >
          {format(day, 'd')}
        </div>
      )
    });
  };

  //console.log("renderDays",renderDays)

  return (

    <div className={styles.calendarWrapper}>
      <div className={styles.header}>
        <button className={styles.navButton} onClick={handlePreviousMonth}>
          <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24" id="c-arrow-right" xmlns="http://www.w3.org/2000/svg">
            <path d="m7.301 13 5.43 5.818-1.462 1.364L3.632 12l7.637-8.182 1.462 1.365L7.301 11H21v2H7.301z" />
          </svg>
        </button>
        <span>{format(currentDate, 'MMMM yyyy',{locale:locales[locale]})}</span>
        <button className={styles.navButton} onClick={handleNextMonth}>
          <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24" id="c-arrow-right" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.699 11H3v2h13.699l-5.43 5.818 1.462 1.364L20.368 12 12.73 3.818l-1.46 1.365L16.699 11z" />
          </svg>
        </button>
      </div>

      <div className={styles.calendar}>
        <div className={styles.dayName}>{locale=='es'?'Lun':'Mon'}</div>
        <div className={styles.dayName}>{locale=='es'?'Mar':'Tue'}</div>
        <div className={styles.dayName}>{locale=='es'?'Mie':'Wed'}</div>
        <div className={styles.dayName}>{locale=='es'?'Jue':'Thu'}</div>
        <div className={styles.dayName}>{locale=='es'?'Vie':'Fri'}</div>
        <div className={styles.dayName}>{locale=='es'?'Sab':'Sat'}</div>
        <div className={styles.dayName}>{locale=='es'?'Dom':'Sun'}</div>

        {renderDays()}

      </div>

    </div>
  );
}

export default EmdbDatePicker;
